import { EntryWithID, LimitPagination } from '@/components/cms/types/entry';
import {
  FaqItem,
  transformPagesIntoSearchProps,
} from '@/decodo/blocks/HeroWithSearch/service';

export const SEARCHED_PAGES = 50;

export interface State {
  loading: boolean;
  results: FaqItem[];
  title?: string;
}

interface LoadingAction {
  type: 'loading_pages';
}

interface ErrorAction {
  type: 'no_pages';
  payload: {
    query?: string;
  };
}

interface SearchedPagesAction {
  type: 'searched_pages';
  payload: {
    results: {
      data: EntryWithID[];
    };
  };
}
interface FilteredPageAction {
  type: 'filtered_pages';
  payload: {
    results: {
      data: EntryWithID[];
      pagination: LimitPagination;
    };
    query?: string;
  };
}

export type Action =
  | LoadingAction
  | ErrorAction
  | SearchedPagesAction
  | FilteredPageAction;

export function reducer(state: State, action: Action): State {
  if (action.type === 'loading_pages') {
    return {
      ...state,
      loading: true,
    };
  }
  if (action.type === 'no_pages') {
    return {
      results: [],
      loading: false,
    };
  }
  if (action.type === 'searched_pages') {
    const newPages = transformPagesIntoSearchProps(action.payload.results.data);
    return {
      ...state,
      loading: false,
      results: newPages,
    };
  }
  throw Error(`Unknown action: ${action}`);
}

export function generateInitialState({
  results,
  title,
}: {
  results?: {
    data: EntryWithID[];
    pagination?: LimitPagination;
  };
  title: string | null;
}): State {
  return {
    title: title ?? undefined,
    loading: false,
    results: results?.data ? transformPagesIntoSearchProps(results?.data) : [],
  };
}
